import {UPDATE_SEARCH_BAR} from "../constants/Search";

const initialState = {
  placeholder: "Search Anything...",
  showSearch: true,
  searchFunction: "all"
}

const search = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_BAR:
      return {
        ...state,
        placeholder: action.placeholder,
        showSearch: action.showSearch,
        searchFunction: action.searchFunction,
      }
    default:
      return state
  }
}

export default search